var map = {
	"./accept.png": "./static/images/accept.png",
	"./address_icon.png": "./static/images/address_icon.png",
	"./admin.png": "./static/images/admin.png",
	"./admin_no.png": "./static/images/admin_no.png",
	"./apk.png": "./static/images/apk.png",
	"./avtar.png": "./static/images/avtar.png",
	"./bg.png": "./static/images/bg.png",
	"./complainNo.png": "./static/images/complainNo.png",
	"./complainPhoneNumber.png": "./static/images/complainPhoneNumber.png",
	"./complainUsername.png": "./static/images/complainUsername.png",
	"./computer.png": "./static/images/computer.png",
	"./deal.png": "./static/images/deal.png",
	"./delete.png": "./static/images/delete.png",
	"./deliveryman.png": "./static/images/deliveryman.png",
	"./deliveryman_no.png": "./static/images/deliveryman_no.png",
	"./exit.png": "./static/images/exit.png",
	"./icon/NEEWER_Control-app-icon-optimized-9b9ab116-d204-4754-b3ac-fc8876f57c6a.png": "./static/images/icon/NEEWER_Control-app-icon-optimized-9b9ab116-d204-4754-b3ac-fc8876f57c6a.png",
	"./icon/banben.png": "./static/images/icon/banben.png",
	"./icon/banben@2x.png": "./static/images/icon/banben@2x.png",
	"./icon/home.png": "./static/images/icon/home.png",
	"./icon/home@2x.png": "./static/images/icon/home@2x.png",
	"./icon/import_icon_preview_sel.png": "./static/images/icon/import_icon_preview_sel.png",
	"./icon/import_icon_preview_sel@2x.png": "./static/images/icon/import_icon_preview_sel@2x.png",
	"./icon/import_icon_suc_sel.png": "./static/images/icon/import_icon_suc_sel.png",
	"./icon/import_icon_suc_sel@2x.png": "./static/images/icon/import_icon_suc_sel@2x.png",
	"./icon/import_icon_upload_sel.png": "./static/images/icon/import_icon_upload_sel.png",
	"./icon/import_icon_upload_sel@2x.png": "./static/images/icon/import_icon_upload_sel@2x.png",
	"./icon/mult_effect_order.png": "./static/images/icon/mult_effect_order.png",
	"./icon2.png": "./static/images/icon2.png",
	"./image_icon.png": "./static/images/image_icon.png",
	"./login.png": "./static/images/login.png",
	"./login_pic_logo.svg": "./static/images/login_pic_logo.svg",
	"./logistics.png": "./static/images/logistics.png",
	"./logistics_dfh.png": "./static/images/logistics_dfh.png",
	"./logistics_order.png": "./static/images/logistics_order.png",
	"./logistics_ps.png": "./static/images/logistics_ps.png",
	"./logistics_zt.png": "./static/images/logistics_zt.png",
	"./logo-grey.png": "./static/images/logo-grey.png",
	"./logo.png": "./static/images/logo.png",
	"./logo@2x.png": "./static/images/logo@2x.png",
	"./mune_icon2.png": "./static/images/mune_icon2.png",
	"./mune_icon3.png": "./static/images/mune_icon3.png",
	"./mune_icon5.png": "./static/images/mune_icon5.png",
	"./mune_icon6.png": "./static/images/mune_icon6.png",
	"./mune_icon8.png": "./static/images/mune_icon8.png",
	"./mune_icon9.png": "./static/images/mune_icon9.png",
	"./notice.png": "./static/images/notice.png",
	"./permissions.png": "./static/images/permissions.png",
	"./plus.png": "./static/images/plus.png",
	"./refund_filed.png": "./static/images/refund_filed.png",
	"./refund_review.png": "./static/images/refund_review.png",
	"./refund_sucess.png": "./static/images/refund_sucess.png",
	"./steps1.png": "./static/images/steps1.png",
	"./steps2.png": "./static/images/steps2.png",
	"./steps3.png": "./static/images/steps3.png",
	"./time_icon_one.png": "./static/images/time_icon_one.png",
	"./time_two.png": "./static/images/time_two.png",
	"./top_icon1.png": "./static/images/top_icon1.png",
	"./top_icon2.png": "./static/images/top_icon2.png",
	"./top_icon3.png": "./static/images/top_icon3.png",
	"./top_icon4.png": "./static/images/top_icon4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./static/images sync recursive ^\\.\\/.*$";